import {
  FETCHING_ACCOUNT_ASSETS,
  FETCHING_ACCOUNT_ASSETS_FAILED,
  FETCHING_ACCOUNT_ASSETS_SUCCEEDED,
  INVALID_REPROCESSING_ASSET,
  RE_TRIGGER_ASSET,
  RE_TRIGGER_ASSET_FAILED,
  RE_TRIGGER_ASSET_SUCCEEDED
} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";

import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const ASSET_TRANSACTION_BASE_URL = `${API_URL}/api/1.0/asset_processing`;


/** fetch shares */
export const fetchAllAssets = createAction(FETCHING_ACCOUNT_ASSETS);
const fetchAllAssetsSucceeded = createAction(FETCHING_ACCOUNT_ASSETS_SUCCEEDED);
const fetchAllAssetsFailed = createAction(FETCHING_ACCOUNT_ASSETS_FAILED);

function* fetchAccountAssets(action) {
  let { page, limit, filters } = action.payload;

  let url = buildUrl(ASSET_TRANSACTION_BASE_URL, { path: `/${filters.accountId}` });
  const fetchAllAssetsAPI = () => {

    return axios({
      method: "POST",
      url: url,
      params: { page, limit },
      data: filters
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAllAssetsAPI);
    yield put(fetchAllAssetsSucceeded(response));
  } catch (error) {
    yield put(fetchAllAssetsFailed(error));
  }
}

export const triggerReprocessingForAsset = createAction(RE_TRIGGER_ASSET);
export const invalideReTriggerAsset = createAction(INVALID_REPROCESSING_ASSET)
const retriggerAssetSucceeded = createAction(RE_TRIGGER_ASSET_SUCCEEDED);
const retriggerAssetFailed = createAction(RE_TRIGGER_ASSET_FAILED);

function* retriggerAssetProcessing(action) {
  
  let { page, limit, assetId } = action.payload;

  let url = buildUrl(ASSET_TRANSACTION_BASE_URL, { path: `/${assetId}/process` });
  const reprocessingAssetAPI = () => {

    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(reprocessingAssetAPI);
    yield put(retriggerAssetSucceeded(response));
  } catch (error) {
    yield put(retriggerAssetFailed(error));
  }
}

export default function* accountAssetTransactionSaga() {
  yield takeLatest(FETCHING_ACCOUNT_ASSETS, fetchAccountAssets);
  yield takeLatest(RE_TRIGGER_ASSET, retriggerAssetProcessing);
}
